export default __webpack_public_path__ + "static/media/logo-governo-ceara-50px.6e2d012f.png";